import { c as _c } from "react/compiler-runtime";
import { numberConvert } from "@website/utils/number-convert";
import padStart from "lodash-es/padStart";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
export const useCountDownTimer = properties => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Date.now();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [now, setNow] = useState(t0);
  const interval = useRef(undefined);
  const router = useRouter();
  const locale = router.locale ?? "fa";
  let t1;
  if ($[1] !== locale) {
    t1 = number => numberConvert(padStart(toString(number), 2, "0"), {
      locale
    });
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const calcNumber = t1;
  let t2;
  if ($[3] !== now || $[4] !== properties.differenceFrom) {
    t2 = properties.differenceFrom ?? new Date(now).setHours(24, 0, 0);
    $[3] = now;
    $[4] = properties.differenceFrom;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const difference = t2 / 1000;
  let t3;
  if ($[6] !== difference || $[7] !== now || $[8] !== properties.differenceFrom || $[9] !== properties.resetOnEnd) {
    t3 = properties.resetOnEnd && difference - now / 1000 < 0 ? ((properties.differenceFrom ?? new Date(now).setHours(24, 0, 0)) - now) / 1000 : difference - now / 1000;
    $[6] = difference;
    $[7] = now;
    $[8] = properties.differenceFrom;
    $[9] = properties.resetOnEnd;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const deltaTime = t3;
  let t4;
  let t5;
  if ($[11] !== deltaTime || $[12] !== properties) {
    t4 = () => {
      if (!(deltaTime >= 1)) {
        !properties.resetOnEnd && clearInterval?.(interval?.current);
        interval.current = undefined;
        properties.onTimeEnd?.();
      }
    };
    t5 = [deltaTime, properties];
    $[11] = deltaTime;
    $[12] = properties;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[15] !== properties.stopTimer) {
    t6 = () => {
      if (!interval.current && !properties.stopTimer) {
        interval.current = setInterval(() => setNow(Date.now()), 1000);
      }
      return () => {
        clearInterval?.(interval?.current);
      };
    };
    t7 = [properties.stopTimer];
    $[15] = properties.stopTimer;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  if ($[18] !== calcNumber || $[19] !== deltaTime) {
    t8 = deltaTime >= 1 ? {
      hours: calcNumber(deltaTime ? Math.floor(deltaTime / 3600 % 24) : 0),
      minutes: calcNumber(deltaTime ? Math.floor(deltaTime / 60 % 60) : 0),
      seconds: calcNumber(deltaTime ? Math.floor(deltaTime % 60) : 0),
      originalTime: deltaTime || 0
    } : null;
    $[18] = calcNumber;
    $[19] = deltaTime;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = {
      timeLeft: t8
    };
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};